/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
import { Modal } from "react-bootstrap"
import BaseCom from "./BaseCom"
import { getLang } from "../shared/GLang";
import L from "./Lang";
import Globals from "../shared/Globals";


export const InfoModalGlobal = {
    show: (title,children) => {} 
};


export class InfoModal extends BaseCom {
    constructor(props) {
        super(props);
        InfoModalGlobal.show = this.show;
    }


    show = (title,children) => {
        this.setState({ title: title, children: children, show: true });
        this.forceUpdate();
    }

    hide = () => {
        this.setState({ show: false });
    }

    render() {
        return <Modal show={this.state.show} onHide={this.hide} size="lg">
            {this.state.title && <Modal.Header closeButton>
                <Modal.Title><L>{this.state.title}</L></Modal.Title>
            </Modal.Header>}
            <Modal.Body>
                {this.state.children}
            </Modal.Body>
        </Modal>;
    }
}